// import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

export default function Meta({ title, desc, url, keywords }) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        {keywords && <meta name="keywords" content={keywords} />}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta
          property="og:image"
          content="https://fusionmybusiness.com/assets/logo-removebg-7RK6hp6E.png"
        />
        <meta property="og:url" content={url} />
        <link rel="canonical" href={url} />
      </Helmet>
    </>
  );
}

Meta.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  keywords: PropTypes.string,
};
